// this area doesn't have a navigation item in the navbar

import type { AreaNavigationProps } from '@backoffice-frontend/patterns'

export const StatusAreaNavigation = (_props: AreaNavigationProps) => {
  return null
}
